import { render, staticRenderFns } from "./AsAMasterPage.vue?vue&type=template&id=250cb9ae&scoped=true"
import script from "./AsAMasterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AsAMasterPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsAMasterPage.vue?vue&type=style&index=0&id=250cb9ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250cb9ae",
  null
  
)

export default component.exports